import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlatList, StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import theme from 'shared/styles/theme';
import useVaroUserFlow from 'shared/utils/useVaroUserFlow/useVaroUserFlow';

const StatementsAndFormsScreen = () => {
  const router = useRouter();
  const flow = useVaroUserFlow();
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'statementsAndForms',
  });

  const listOfStatementsAndForms = [
    {
      id: '1',
      primaryCopy: translatedText('accountStatements.title'),
    },
    {
      id: '2',
      primaryCopy: translatedText('taxStatements.title'),
    },
  ];

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          title: translatedText('title'),
          headerShown: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
          headerBackVisible: true,
        }}
      />

      <FlatList
        data={listOfStatementsAndForms}
        renderItem={({ item }) => (
          <ListItem
            key={item?.id}
            primaryCopy={item?.primaryCopy}
            onPress={() => {
              if (item.id === '1') {
                router.push({
                  pathname: `/${flow}/statements-and-forms/account-statements`,
                });
              } else {
                router.push({
                  pathname: `/${flow}/statements-and-forms/tax-statements`,
                });
              }
            }}
          />
        )}
        ItemSeparatorComponent={() => (
          <View style={styles.hairLineDivider}>
            <HairLineDivider />
          </View>
        )}
        keyExtractor={(item) => item?.id}
        removeClippedSubviews={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
  },
  hairLineDivider: { marginHorizontal: theme.spacing.m },
});

export default StatementsAndFormsScreen;
